import { useLocation } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { setPreviousUrl } from 'shared/client/previousUrl';

export function RouteChangeTracker() {
  const { pathname, searchStr } = useLocation();
  const previousUrlRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (previousUrlRef.current !== undefined) {
      setPreviousUrl(previousUrlRef.current);
    }
    // Normalize a leading `?`: depending on the route/search shape `searchStr` may or may not include
    // one, and blindly prefixing produced a malformed `…path??query` referer. A double `?` makes the
    // server mis-parse the FIRST query key (e.g. `?slxapi` instead of `slxapi`), so the server-side
    // slxapi context is lost — and thus 720 state persistence + xAPI-event routing to kata silently break.
    previousUrlRef.current = window.location.origin + pathname + (searchStr ? `?${searchStr.replace(/^\?+/, '')}` : '');
  }, [pathname, searchStr]);

  return null;
}
